module.exports = __webpack_public_path__ + "img/old_meleze_light_brown.23d1b34b.jpg";